import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../stylesheets/resource.scss";
import FeedbackList from "./FeedbackList";
class FeedbackView extends React.Component {
	render() {
		return (
			<div className="container-fluid pl-2 pr-2">
				<FeedbackList history={this.props.history} />
			</div>
		);
	}
}

export default FeedbackView;
